import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { Icon } from '../components/ui/icon.js';
import { Button } from '../components/ui/button.js';
import { GamePage } from '@/features/originals/shell/GamePage.js';

const searchSchema = z.object({
  session: z.string().optional(),
});

export const Route = createFileRoute('/_player/games/originals/$code')({
  validateSearch: searchSchema,
  component: OriginalsGamePage,
});

function OriginalsGamePage() {
  const { code } = Route.useParams();
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-4 w-full max-w-[1180px] mx-auto">
      <Button variant="secondary" size="sm" onClick={() => void navigate({ to: '/casino' })} className="self-start">
        <Icon name="arrowRight" size={15} className="rotate-180" />
        {t('nav.casino')}
      </Button>
      <GamePage code={code} />
    </div>
  );
}
